export enum OverviewDashboardSortEnum {
  Newest = 'desc',
  Oldest = 'asc',
  LastCritical = 'descCritical',
  LastAtRisk = 'descAtRisk',
}
